const CHANNEL = 'gillyreach-oauth-v1';
const STORAGE_KEY = 'gillyreach_oauth_event';
export const OAUTH_FLOW_STORAGE = 'gillyreach_oauth_flow';

/** Set when user starts OAuth from openOAuthInNewTab (separate-tab flow). */
export function markOAuthFlowStarted({ provider, accountEmail }) {
  try {
    sessionStorage.setItem(
      OAUTH_FLOW_STORAGE,
      JSON.stringify({
        provider,
        accountEmail: accountEmail || null,
        at: Date.now(),
      })
    );
  } catch {
    /* ignore */
  }
}

export function consumeOAuthFlowStarted() {
  try {
    const raw = sessionStorage.getItem(OAUTH_FLOW_STORAGE);
    sessionStorage.removeItem(OAUTH_FLOW_STORAGE);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

/** Notify other same-origin tabs that OAuth finished. */
export function publishOAuthResult({ provider, ok }) {
  const payload = { provider, ok, at: Date.now() };
  try {
    const ch = new BroadcastChannel(CHANNEL);
    ch.postMessage(payload);
    ch.close();
  } catch {
    /* ignore */
  }
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

export function subscribeOAuthResult(handler) {
  const onMessage = (event) => {
    if (event?.data?.provider) handler(event.data);
  };
  let channel;
  try {
    channel = new BroadcastChannel(CHANNEL);
    channel.onmessage = onMessage;
  } catch {
    /* ignore */
  }
  const onStorage = (event) => {
    if (event.key !== STORAGE_KEY || !event.newValue) return;
    try {
      handler(JSON.parse(event.newValue));
    } catch {
      /* ignore */
    }
  };
  window.addEventListener('storage', onStorage);
  return () => {
    if (channel) channel.close();
    window.removeEventListener('storage', onStorage);
  };
}
